import React, { useEffect } from "react";

const Snackbar1 = ({
  open,
  close_snack_bar = () => {},
  message,
  duration = 2000,
}) => {

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        close_snack_bar();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [open, close_snack_bar, duration]);

  return (
    <div
      style={{
        position: "fixed",
        top: open ? "40px" : "20px",
        left: "50%",
        transform: "translateX(-50%)",
        minWidth: "260px",
        maxWidth: "90%",
        padding: "14px 20px",
        borderRadius: "10px",
        color: "#fff",
        background: "rgba(34, 197, 94, 0.95)", // Green Glass look
        boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        zIndex: 9999,
        backdropFilter: "blur(6px)",
        transition: "all 0.35s ease-in-out",
        opacity: open ? 1 : 0,
        pointerEvents: open ? "auto" : "none",
      }}
    >
      {/* Icon */}
      <div
        style={{
          background: "#fff",
          color: "green",
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        ✓
      </div>

      {/* Message */}
      <span style={{ fontSize: "15px", flex: 1 }}>{message}</span>

      {/* Close Button */}
      <button
        onClick={close_snack_bar}
        style={{
          background: "transparent",
          border: "none",
          color: "#fff",
          fontSize: "18px",
          cursor: "pointer",
          padding: 0,
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default Snackbar1;
